<template>
    <div class="unsubscribe-wrapper">
        <div class="unsubscribe">
            <div>
                <p class="unsubscribe__title unsubscribe__text">
                    You'll no longer receive these emails from CrossProm
                </p>
                <p class="unsubscribe__text">
                    Manage your email preferences
                </p>
            </div>
            <a-checkbox-group v-model="checkedTypes" class="unsubscribe__type-list">
                <a-checkbox class="unsubscribe__type-list__item unsubscribe__text ml-0" v-for="(item) in emailTypes" :key="item.type" :value="item.type">
                    {{item.text}}
                </a-checkbox>
            </a-checkbox-group>
            <div class="unsubscribe__footer">
                <button @click="checkAll" class="unsubscribe__" type="primary_outline">Unsubscribe From All</button>
                <button @click="save(false)" class="unsubscribe__save" type="primary">Save Changes</button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Button from '@/components/Theme/Button'
import { db } from '../../firebase'
import { message } from 'ant-design-vue'

export default {
    name: 'Unsubscribe',
    components: {
        Button
    },
    data() {
        return {
            emailTypes: [
                {
                    type: 'premium',
                    text: 'Premium Expiration'
                },
                {
                    type: 'updatesDueSoon',
                    text: 'Updates Due Soon'
                },
                {
                    type: 'newsletter',
                    text: 'Weekly Newsletter'
                },
                {
                    type: 'updatePosted',
                    text: 'Update Posted'
                }
            ],
            checkedTypes: [],
        }
    },
    computed: {
        ...mapState([
            'user'
        ])
    },
    async mounted() {
        await this.initCheckedList()
        const initialUnsubscription = this.$route.query.unsubscribeFrom
        if(initialUnsubscription && this.emailTypes.find(item => item.type === initialUnsubscription && !this.checkedTypes.includes(initialUnsubscription))){
            this.checkedTypes.push(initialUnsubscription)
            await this.save(true)
            this.$router.replace(this.$router.replace({ query: {} })).catch(() => {})
        }
    },
    methods: {
        checkAll() {
            this.checkedTypes = this.emailTypes.map((el) => el.type)
            this.save(null, true)
        },
        async initCheckedList() {
            const doc = await db.collection('Users')
                .doc(this.user.userId)
                .get()
                
            if(!doc.data().unsubscribe || !doc.data().unsubscribe.length) {
                return 
            }
            this.checkedTypes = doc.data().unsubscribe
        },
        save(initialSave, unsubscribeFromAll) {
            return db.collection('Users')
                .doc(this.user.userId)
                .update({
                    unsubscribe: [...this.checkedTypes]
                })
                .then(() => {
                    if(initialSave) return
                    if(unsubscribeFromAll){
                        message.success('You are successfully unsubscribed from all the emails')
                        return
                    }
                    message.success('Your email preferences are saved')
                })
                .catch((e) => console.log(e))
        },
    },

}
</script>

<style lang="scss">
    .unsubscribe {
        .ant-checkbox + span{
            display: block;
            margin-top: -6px;
        }
    }
</style>

<style lang="scss" scoped>
$max_width: 656px;
$color: #000000;
$button_color: #8DA0A9;
$title_fontsize: 20px;
$title_lineheight: 23px;
$font_bold: 'Eina Bold';
$fontsize: 16px;
$lineheight: 19px;
$padding: 48px 63px;
$white: #ffffff;
$button_height: 43px;
$button_save_width: 188px;
$button_unsbsc_width: 260px;
$primary: #727CF5;
$secondary: #858585;
$radius: 5px;
$transition: all 0.2s ease;

.unsubscribe-wrapper {
    min-height: calc(100vh - 180px);   
    display: flex;
    align-items: center;
    padding: 20px 0;
    background: #f4f4f4;
}
.unsubscribe {
    width: 100%;
    max-width: $max_width;
    display: flex;
    flex-direction: column;
    padding: $padding;
    background: $white;
    margin: 0 auto;
    &__text {
        color: $color;
        margin-bottom: 0;
        font-size: $fontsize;
        line-height: $lineheight;
    }
    &__title {
        font-size: $title_fontsize;
        line-height: $title_lineheight;
        font-family: $font_bold;
        margin-bottom: 8px;
    }
    &__type-list {
        margin-top:24px;
        padding-left: 0;
        &__item {
            width: fit-content;
            margin-top: 20px;
            display: flex;
            align-items: center;
        }
    }
    &__footer {
        display: flex;
        margin-top: 56px;
        justify-content: flex-end;
        button {
            padding: 12px 0;
            width: 210px;
            font-size: $fontsize;
            border-radius: $radius;
            font-family: 'Eina SemiBold';
            transition: $transition;
        }
    }
    &__save {
        color: $white;
        background: $primary;
        &:hover {
            box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);
        }
    }
    &__ {
        margin-right: 8px;
        border: 1px solid $secondary;
        color: $button_color;
        &:hover {
            color: $white;
            background: $secondary;
        }
    }
    
}
</style>